import { createTheme } from "@mui/material/styles";

// Create a theme instance.
// https://mui.com/material-ui/customization/default-theme/
// https://bareynol.github.io/mui-theme-creator/
const theme = createTheme({
  typography: {
    button: {
      fontWeight: 600, // Buttonの中のtextを太字にする
    },
  },
  components: {
    MuiToolbar: {
      styleOverrides: {
        dense: {
          minHeight: 40,
        },
      },
    },
  },
});

export default theme;
